import { render, staticRenderFns } from "./CookiesComponent.vue?vue&type=template&id=c665f02a&scoped=true&"
import script from "./CookiesComponent.vue?vue&type=script&lang=js&"
export * from "./CookiesComponent.vue?vue&type=script&lang=js&"
import style0 from "./CookiesComponent.vue?vue&type=style&index=0&id=c665f02a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c665f02a",
  null
  
)

export default component.exports